import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/PersonalLearningDashboard.css";

const PersonalLearningDashboard = () => {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/course-participants/courses/${localStorage.getItem("userEmail")}`)
            .then(res => res.json())
            .then(data => {
                setCourses(data);
                setLoading(false);
            })
            .catch(err => {
                setError("Kurslar yüklenemedi.");
                setLoading(false);
            });
    }, []);

    const handleDetailClick = (courseId) => {
        navigate(`/personal-learning/course/${courseId}`);
    };

    return (
        <div className="learning-dashboard">
            <h2 className="dashboard-title">
                <span className="emoji">🎯</span>
                Kişisel Öğrenme Paneli
            </h2>
            {loading ? (
                <p>Yükleniyor...</p>
            ) : error ? (
                <p className="error">{error}</p>
            ) : (
                <div className="horizontal-course-list">
                    {courses.map((course, index) => (
                        <div
                            key={course.id}
                            className={`horizontal-course-card color-${(index % 10) + 1}`}
                        >
                            <div className="course-info">
                                <h3>{course.name}</h3>
                                <p><strong>Kod:</strong> {course.courseCode}</p>
                                <p><i className="fa fa-calendar" /> Başlangıç: {course.startDate}</p>
                                <p><i className="fa fa-clock" /> Bitiş: {course.endDate}</p>
                            </div>
                            <div className="course-actions">
                                <button
                                    className="detail-button"
                                    onClick={() => handleDetailClick(course.id)}
                                >
                                    Detaylar
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default PersonalLearningDashboard;
